import { api, getStoredToken } from "./http";

/**
 * Sign the newly created applicant in and persist the auth token.
 *
 * The payment verification endpoint requires a bearer token. Applicants who
 * have just submitted the public form have not logged in yet, so the token has
 * to be obtained here before they reach the payment page.
 */
export async function startApplicantSession({ email, password } = {}) {
  if (!email || !password) {
    return getStoredToken();
  }

  try {
    const response = await api.post("/api/applicant-login", { email, password });
    const token = response?.token || response?.data?.token;

    if (!token) {
      return getStoredToken();
    }

    localStorage.setItem("_token", JSON.stringify(token));

    if (response?.user_id) {
      localStorage.setItem("applicantId", response.user_id);
    }

    return token;
  } catch (error) {
    console.warn(
      "[mu-admissions] Could not start the applicant session:",
      error?.message || error
    );

    return getStoredToken();
  }
}
